module.exports = __webpack_public_path__ + "img/mini-x.2f196661.svg";